import { capitalize } from "shared/utils";
import { KeyValue } from "views/applications-id-report/components/KeyValue";
import { ReverifyAttempt } from "../../../ReverifySlice/types";
import { isReverifyTabAPlaceholder } from "../../../ReverifySlice/utils";

export const VerifiedReportedStats = ({
  selectedReverifyAttempt
}: {
  selectedReverifyAttempt?: ReverifyAttempt;
}) => {
  const isGroupedItems = Array.isArray(selectedReverifyAttempt);
  if (isGroupedItems || isReverifyTabAPlaceholder(selectedReverifyAttempt))
    return null;

  return (
    <div className="space-y-3">
      {selectedReverifyAttempt?.data &&
      "accounts" in selectedReverifyAttempt.data &&
      selectedReverifyAttempt.data.accounts[0] ? (
        <div className="space-y-3">
          <KeyValue
            label="Account ID"
            value={selectedReverifyAttempt.data.accounts[0].account_id}
          />
        </div>
      ) : null}
      {selectedReverifyAttempt?.data &&
      "account" in selectedReverifyAttempt.data ? (
        <>
          <KeyValue
            label="Bank account"
            value={
              capitalize(selectedReverifyAttempt.data.account.type) +
              " ***" +
              selectedReverifyAttempt.data.account.mask
            }
          />
          <KeyValue
            label="Institution"
            value={selectedReverifyAttempt.data.account.name || "Unknown"}
          />

          <KeyValue
            label="Source bank account"
            value={
              capitalize(selectedReverifyAttempt.data.account.type) +
              " ***" +
              selectedReverifyAttempt.data.account.mask
            }
          />
        </>
      ) : null}
    </div>
  );
};
